var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "swiper vue-swiper", class: "s-" + _vm.itemId },
    [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.images, function (image) {
          return _c("div", { staticClass: "swiper-slide" }, [
            _c(
              "div",
              {
                staticClass: "thumb-image img-content",
                class: { "swiper-zoom-container": _vm.isZoom },
              },
              [
                _c("img", {
                  staticClass: "img-responsive swiper-lazy",
                  attrs: { "data-src": image },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-lazy-preloader" }),
              ]
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination" }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-prev" }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-next" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }